import { BaseService } from "./BaseService";
import { SnackBarModule } from "../modules/SnackBarModule";

export const AgendarFeriasCivilService = {
  async agendarFerias(postData) {
    
    const response = await BaseService.fetchResponseFromAPIPost(
      `civil/ferias/agendar`,
      postData,
    );
    if (response.error) {
      const errorMessage = await response.message;
      SnackBarModule(errorMessage.error || 'Preencha todos os campos', "error");
      return false;
    }
    SnackBarModule("Enviado com sucesso", "success");
    return true;
  },
  
  async interromperFerias(postData) {
    
    const response = await BaseService.fetchResponseFromAPIPost(
      `reprogramacao`,
      postData,
    );
    if (response.error) {
      SnackBarModule(response.message, "error");
      return false;
    }
    SnackBarModule("Enviado com sucesso", "success");
    return true;
  },

  async validaExibicaoReprogramarFerias() {
    const response = await BaseService.fetchResponseFromAPIGet(
      `civil/valida-reprogramacao`
    );
    if (response.error) {
      return false;
    }
    return response.content;
  },

  async getTipoCivil(id) {
    const response = await BaseService.fetchResponseFromAPIGet(`pessoa/${id}/tipo-civil`);
    if (response.error) {
      SnackBarModule("Houve um erro ao consultar o tipo do civil", "error");
    }
    return response.content;
  },

  async pegarPessoasPorUnidadeComFerias(id) {
    
    const response = await BaseService.fetchResponseFromAPIGet(
      `pessoa/ferias/${id}/unidade`,
      
    );
    if (response.error) {
      SnackBarModule("Erro pegar pessoas por unidade", "error");
      return false;
    }
    return response.content;
  },

  async pegarPessoasSemFerias() {
    
    const response = await BaseService.fetchResponseFromAPIGet(
      `pessoa/sem-ferias`,
      
    );
    if (response.error) {
      SnackBarModule("Erro pegar pessoas por unidade", "error");
      return false;
    }
    return response.content;
  },

  
  async pegarPessoasPorUnidadeSemFerias(id) {
    
    const response = await BaseService.fetchResponseFromAPIGet(
      `pessoa/${id}/unidade?civil=true`,
      
    );
    if (response.error) {
      SnackBarModule("Erro pegar pessoas por unidade", "error");
      return false;
    }
    return response.content;
  },

  async pegarGraduacaoPorPessoa(id) {
    
    const response = await BaseService.fetchResponseFromAPIGet(
      `graduacao/${id}/pessoa`,
      
    );
    if (response.error) {
      SnackBarModule("Erro pegar graduação por pessoa", "error");
      return false;
    }
    return response.content;
  },

  async pegarDiasPendentesDaPessoa(exercicio,id) {
    
    const response = await BaseService.fetchResponseFromAPIGet(
      `ferias/${exercicio}/pessoa/${id}`,
      
    );
    if (response.error) {
      SnackBarModule("Erro pegar dias pendentes", "error");
      return false;
    }
    return response.content;
  },

  async pegarParcelasDaPessoa(exercicio,id) {
    
    const response = await BaseService.fetchResponseFromAPIGet(
      `ferias/${exercicio}/pessoa/${id}/parcelas`,
      
    );
    if (response.error) {
      SnackBarModule("Erro pegar dias pendentes", "error");
      return false;
    }
    return response.content;
  },
  
}